// extracted by mini-css-extract-plugin
export default {"scope":"QHHd6","header":"_0X1nM","headline":"_5Vz2v","content":"a2kyH"};